
const AcademicReadinessTestimonialData = [
    {
        id: 1,
        heading: "I Felt Ready Before I Even Landed",
        text: "The bootcamp helped me understand how classes actually work abroad. I knew what professors expected, how to manage my time, and how to participate confidently. It felt like I’d already started university before I arrived.",
        name: "Amina, UAE | Studying Psychology in Toronto"
    },
    {
        id: 2,
        heading: "It Made Me Less Afraid of Failing",
        text: "I was nervous about academic writing and group projects. The bootcamp broke it down in simple steps. I now use the time management tips every week—and my grades show it.",
        name: "Hassan, Saudi Arabia | Engineering Student in Boston"
    },
    {
        id: 3,
        heading: "I Didn’t Know What I Didn’t Know",
        text: "I thought I was prepared until I saw Day 3 of the bootcamp—plagiarism rules, citation formats, and classroom etiquette. It saved me from making rookie mistakes.",
        name: "Fatima, Oman | Law Student in London"
    },
    {
        id: 4,
        heading: "I Still Use the Planner They Sent",
        text: "The bootcamp came with a study planner that I still use today. It helped me organize assignments, track deadlines, and avoid burnout. I’ve shared it with three classmates.",
        name: "Mohammed, Bahrain | Business Major in Sydney"
    },
    {
        id: 5,
        heading: "It Was the Best Free Resource I Found",
        text: "I signed up for the bootcamp thinking it was just emails. It turned out to be a full academic prep course—bite-sized, practical, and made for Gulf students like me.",
        name: "Layla, Qatar | Computer Science, University of Leeds"
    },
    
];

export default AcademicReadinessTestimonialData;